import { getPendingImage } from "view/components/RichTextEditor/adapters/pendingImages";
import { Image } from "view/components/RichTextEditor/types";

const SUPPORTED: Image["extension"][] = ["png", "jpg", "jpeg"];
const FALLBACK: Image["extension"] = "png";

const normalize = (value: string | undefined): Image["extension"] | null => {
  const lower = value?.toLowerCase();
  return SUPPORTED.find((supported) => supported === lower) ?? null;
};

/**
 * The extension `CropImage` hands to `canvas.toDataURL("image/<ext>")`.
 *
 * Used to come from `blob.type` after re-fetching the file, which is exactly
 * the network round-trip `useImagesEdit` no longer does (a stored image lives
 * on the storage service, whose responses `<img>` can render but `fetch` may
 * not be allowed to read). Derive it from what's already at hand instead: the
 * pending-images registry for a not-yet-uploaded blob, the path otherwise.
 */
export const getImageExtension = (src: string): Image["extension"] => {
  if (src.startsWith("blob:")) {
    return normalize(getPendingImage(src)?.extension) ?? FALLBACK;
  }
  if (src.startsWith("data:")) {
    return normalize(src.split(";")[0]?.split("/")[1]) ?? FALLBACK;
  }
  // Strip the query/hash before looking at the extension, so
  // `…/x.png?scale=50` doesn't read as `png?scale=50`.
  const path = src.split(/[?#]/)[0];
  return normalize(path.split(".").pop()) ?? FALLBACK;
};
